<div class="modal-header">
  <h4 class="modal-title">{{ titre }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body">
  <p>{{ message }}</p>
  <p>{{ confirmation }}</p>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="cancel()">Annuler</button>
  <button type="button" class="btn btn-primary" (click)="confirm()">Continuer</button>
</div>
